module.exports = __webpack_public_path__ + "cu.b807bc5a92b318dfd166.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/flag-icon-css/flags/4x3/cu.svg
// module id = ../../../../flag-icon-css/flags/4x3/cu.svg
// module chunks = styles